/**
 * CSV, for the two fund reports.
 *
 * RFC 4180 quoting, `\r\n` line endings, and a leading BOM — the BOM because the first thing
 * that happens to this file is that somebody opens it in Excel, and without it a column of
 * addresses comes out mojibake. Values are written exactly as the API published them: an
 * integer of centi-SUN stays an integer of centi-SUN, and the header says so. A spreadsheet
 * that has to be reconciled against the API must hold the same numbers as the API.
 */

const BOM = "﻿";

export function toCsv(header: readonly string[], rows: ReadonlyArray<readonly unknown[]>): string {
  const lines = [header.map(cell).join(",")];
  for (const row of rows) lines.push(row.map(cell).join(","));
  return BOM + lines.join("\r\n") + "\r\n";
}

function cell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Hand the browser a file. A blob URL rather than a `data:` URI: a settlement statement over a
 * long period is megabytes, and a `data:` URI of that size is refused by some browsers and
 * truncated in others.
 */
export function downloadCsv(filename: string, content: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked on the next tick: revoking synchronously races the download in Safari.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
